import Canvas from'../_internal/components/canvases/canvas';import AxisRefVisualCartesian from'../../../fc-core/src/axis-ref-visuals/axis-ref-component';import{componentFactory}from'../../../fc-core/src/lib';export default function(a){let b,c=a._parseCanvasCosmetics&&a._parseCanvasCosmetics();if(componentFactory(a,Canvas,'canvas',a.config.showVolumeChart?2:1),b=a.getChildren('canvas'),b)for(let a=0,d=b.length;a<d;a++)b[a].configure(c),componentFactory(b[a],AxisRefVisualCartesian,'axisRefVisualCartesian')}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/factories/canvas-axis-ref-cartesian.js
// module id = null
// module chunks = 